import { createApi } from './api';
export function create(_ref) {
  let {
    httpClient
  } = _ref;
  const {
    getMarketingAttributes,
    putMarketingAttributes
  } = createApi(httpClient);
  return {
    getMarketingAttributes,
    putMarketingAttributes
  };
}